import items from "@frog/source/data/games/dice/data/items.jsx"

const fumble = {"title": "Fumble!!", "description": "Whoops...", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")}

export default [
    {
        "unitKey": "dog",
        "number": 110,
        "equipment": {
            "items": {
                "0": {...items["bone-club"], "power": 10},
                "1": {...items["bone-club"], "power": 20},
                "2": {...items["bone-knife"], "power": 40},
            }
        }
    },
    {
        "unitKey": "dog",
        "number": 110,
        "equipment": {
            "items": {
                "0": {...items["bleeding-blade"], "power": 10},
                "1": {...items["bleeding-blade"], "power": 10},
                "2": {...items["bleeding-blade"], "power": 20},
            }
        }
    },
    {
        "unitKey": "dog",
        "number": 110,
        "equipment": {
            "items": {
                "0": {...items["glaive"], "power": 10},
                "1": {...items["glaive"], "power": 20},
                "2": {...items["glaive"], "power": 20},
                "3": {...items["glaive"], "power": 30},
            }
        }
    },
    {
        "unitKey": "dog",
        "number": 110,
        "equipment": {
            "items": {
                "0": {...items["katana"], "power": 10},
                "1": {...items["katana"], "power": 20},
                "2": {...items["katana"], "power": 30},
            }
        }
    },


    {
        "unitKey": "dog",
        "number": 110,
        "equipment": {
            "items": {
                "2": {...items["zweihander"], "power": 10},
                "3": {...items["zweihander"], "power": 20},
                "4": {...items["zweihander"], "power": 20},
                "5": {...items["zweihander"], "power": 10},
            }
        }
    },
    {
        "unitKey": "dog",
        "number": 110,
        "equipment": {
            "items": {
                "3": {...items["forge-hammer"], "power": 10},
                "4": {...items["warhammer"], "power": 20},
                "5": {...items["warhammer"], "power": 30},
            }
        }
    },
    // {
    //     "unitKey": "dog",
    //     "number": 110,
    //     "equipment": {
    //         "items": {
    //             "3": {...items["buckler"], "power": 30},
    //             "5": {...items["tomahawk"], "power": 10},
    //             "4": {...items["tomahawk"], "power": 10},
    //         }
    //     }
    // },
    {
        "unitKey": "dog",
        "number": 110,
        "equipment": {
            "items": {
                "3": {...items["bleeding-blade"], "power": 30},
                "5": {...items["bleeding-blade"], "power": 20},
                "4": {...items["bleeding-blade"], "power": 10},
            }
        }
    },


    {
        "unitKey": "frog",
        "number": 110,
        "equipment": {
            "items": {
                "1": {...items["trumpet"], "power": 10},
                "2": {...items["trumpet"], "power": 20},
            }
        }
    },
    {
        "unitKey": "frog",
        "number": 110,
        "equipment": {
            "items": {
                "4": {...items["shillelagh"], "power": 20},
                "5": {...items["shillelagh"], "power": 30},
            }
        }
    },
    {
        "unitKey": "mouse",
        "number": 110,
        "equipment": {
            "items": {
                "0": {...items["assassin-blades"], "power": 30},
                "1": {...items["assassin-blades"], "power": 20},
                "2": {...items["assassin-blades"], "power": 10},
            }
        }
    },
    {
        "unitKey": "mouse",
        "number": 110,
        "equipment": {
            "items": {
                "0": {...items["musket"], "power": 30},
                "1": {...items["musket"], "power": 20},
                "2": {...items["swap"]},
            }
        }
    },
    {
        "unitKey": "mouse",
        "number": 110,
        "equipment": {
            "items": {
                "3": {...items["poison-dagger"], "power": 30},
                "4": {...items["poison-dagger"], "power": 20},
                "5": {...items["rose-dagger"]},
            }
        }
    },
    {
        "unitKey": "mouse",
        "number": 110,
        "equipment": {
            "items": {
                "3": {...items["dodge"]},
                "4": {...items["rapier"], "power": 20},
                "5": {...items["rapier"], "power": 30},
            }
        }
    },
    // unused: shortbow
]
